<template>

  <div>

    <div v-if="!dataItems.length">
      No activity at this time
    </div>

    <div v-infinite-scroll="loadMore"
         infinite-scroll-disabled="busy" infinite-scroll-distance="10">

      <transition-group name="list" tag="div">

      <div :class="{'slats': true, 'highlight': highlightForm == item._id}" v-for="item in dataItems" :key="item._id" class="clickable" @click="onRowClick(item)">

          <span class="el-icon-success text-success"></span>
          <strong v-if="!item.isReaded">{{item.form.title}}</strong>
          <span v-else>{{item.form.title}}</span>
        - {{formatTimeAgo(item.createdAt)}} ago

      </div>
      </transition-group>

      <div class="text-muted loading-list" v-if="loading">
        <span class="el-icon-loading"></span>
        Loading...
      </div>
      <div class="text-center loading-list" v-if="!isFullList && !loading">
        <a href="" @click.prevent="loadMore" class="text-muted">
          <span class="el-icon-arrow-down"></span>
          More...
        </a>
      </div>
    </div>
  </div>

</template>
<style lang="scss">
  @keyframes highlight {
    0% {
      background: yellow;
    }
    100% {
      background: transparent;
    }
  }

  .list-enter-active, .list-leave-active {
    transition: all 1s;
    animation: highlight 2s ease-in-out;
  }
  .list-enter, .list-leave-to {
    opacity: 0;
    transform: translateY(30px);
  }

  .slats.highlight {
    animation: highlight 2s ease-in-out;
  }
  .filter-header {
    margin: 10px 0;
  }

  .sort-container {
    line-height: 36px;
    font-size: 14px;
  }
  .filter-dropdown {
    border-bottom: 1px dotted #aaa;
    font-size: 100%;
    line-height: 24px;
  }

  .slats {
    padding: 17px 0;
    border-bottom: 1px solid rgba(35, 35, 35, .1);

    &:before, &:after {
      content: " ";
      display: table;
      clear: both;
    }
  }
  .loading-list {
    padding: 17px 0;
    text-align: center;
  }

  .clickable {
    cursor: pointer;
  }
</style>
<script>
  import moment from 'moment';
  import FormIcon from 'components/Forms/Icon';
  import FormActions from 'components/Forms/Actions';

  export default {
    props: [],
    components: {
      FormIcon,
      FormActions
    },
    data() {
      const highlightForm = localStorage.highlightFormId;
      delete localStorage.highlightFormId;
      return {
        highlightForm,
        busy: false
      }
    },
    async mounted() {
      await this.$store.dispatch('loadUnreadedSubmissions');
      this.timer = setInterval(() => this.updateList(), 5000);
    },
    beforeDestroy() {
      clearInterval(this.timer);
    },
    computed: {
      loading() {
        return this.$store.state.unreadedLoading;
      },
      page() {
        return this.$store.state.unreadedPage;
      },
      isFullList() {
        return this.$store.state.isUnreadedFullList;
      },
      dataItems() {
        return this.$store.state.unreadedSubmissions;
      },
      totalItems() {
        return this.$store.state.unreadedTotal;
      }
    },
    methods: {
      async updateList() {
        await this.$store.dispatch('loadUnreadedSubmissions', true);
      },
      async loadMore() {
        await this.$store.dispatch('loadUnreadedSubmissionsPage');
      },
      onRowClick(item) {
        this.$router.push({ name: 'FilledFormDetails', params: { id: item.form._id, filledId: item._id } })
      },
      formatTimeAgo(date) {
        return moment(date).fromNow(true);
      }
    }
  };
</script>



// WEBPACK FOOTER //
// UnreadedSubmissionsList.vue?11dccf04